// Mirrors backend/passwordPolicy.js exactly — client-side check is for
// immediate feedback only; the backend is the real enforcement boundary.

// Common weak base words — checked with any trailing digits/punctuation
// stripped off, so "password3", "password123!", "Password1" etc. are all
// caught, not just an exact match on the word itself.
const COMMON_WEAK_BASES = [
  'password', 'passw0rd', 'letmein', 'qwerty', 'qwerty123', 'admin', 'administrator',
  'welcome', 'football', 'dragon', 'monkey', 'master', 'login', 'abc123', 'iloveyou',
  'sunshine', 'princess', 'shadow', 'superman', 'trustno1', 'baseball', 'freedom',
  'whatever', 'qazwsx', 'changeme', 'golfclub', 'golfsociety', 'members', 'member'
];

export function validatePassword(password, minLength = 9) {
  if (!password || password.length < minLength) return `Password must be at least ${minLength} characters long`;
  if (!/[a-z]/.test(password)) return 'Password must include at least one lowercase letter';
  if (!/[A-Z]/.test(password)) return 'Password must include at least one uppercase letter';
  if (!/[0-9]/.test(password)) return 'Password must include at least one number';
  if (!/[^a-zA-Z0-9]/.test(password)) return 'Password must include at least one special character (e.g. ! @ # $ %)';
  const lower = password.toLowerCase();
  const stripped = lower.replace(/[^a-z]+$/, '');
  if (COMMON_WEAK_BASES.includes(lower) || COMMON_WEAK_BASES.includes(stripped)) {
    return 'That password is too common and easy to guess — please choose something less predictable';
  }
  return null;
}

export const PASSWORD_HINT = 'At least 9 characters, with uppercase, lowercase, a number and a special character (e.g. ! @ # $)';
export const PASSWORD_HINT_NEW = 'At least 12 characters, with uppercase, lowercase, a number and a special character (e.g. ! @ # $)';
